import { TextField, type TextFieldProps } from "@/shared/ui/core";

export type DateFieldProps = Omit<TextFieldProps, "type">;

/**
 * Una fecha, con el selector NATIVO del navegador (`type="date"`).
 *
 * Un calendario hecho a mano tendría que reimplementar el teclado
 * (flechas por día, PageUp/PageDown por mes), el idioma de los nombres
 * de los meses, la primera columna de la semana según la región y el
 * anuncio del día enfocado. El nativo trae todo eso y en el móvil abre
 * la rueda del sistema. Aquí no se pide nada que el nativo no dé.
 *
 * El VALOR que produce es `YYYY-MM-DD`, y el contrato pide una fecha con
 * hora (`z.iso.datetime()`). La conversión —día → medianoche UTC— vive
 * en `productForm.ts`, no aquí: este campo solo captura el día.
 *
 * Candidato a `shared/ui/fields/`.
 */
export function DateField(props: DateFieldProps) {
  return <TextField type="date" autoComplete="off" {...props} />;
}
